import React from 'react';
import { Outlet } from 'react-router-dom';

export const AuthLayout: React.FC = () => {
  return (
    <div
      style={{ backgroundColor: '#f5f7fb' }}
      className="min-h-screen w-full flex items-center justify-center p-4"
    >
      <Outlet />
    </div>
  );
};
